import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2gvr4jr26k: FaireBrandEntity = {
  token: "b_2gvr4jr26k",
  type: "brand",
  name: "MIO WHOLESALE",
  avatarUrl:
    "https://cdn.faire.com/fastly/25eb6fcc859df6ef06df5cf9c6771d7b283fda053b0fa8247d6962de4cdae7c8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/311f8a36a4ef57e4f0e5c9496c9884aff2fa926e4f249de7e309e5ff1d1d39f8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/25eb6fcc859df6ef06df5cf9c6771d7b283fda053b0fa8247d6962de4cdae7c8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/311f8a36a4ef57e4f0e5c9496c9884aff2fa926e4f249de7e309e5ff1d1d39f8.jpeg",
  location: "los angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.5,
  reviewCount: 33,
  isInsider: true,
  description:
    "MIO WHOLESALE is a fashion-forward women’s clothing wholesaler in Downtown, Los Angeles. Mio Wholesale specializes in Wholesale Fashion Clothing.\n\nWe offer a mix of Contemporary and Plus Size for women of all ages. We carry top-quality fashion products MADE in the U.S.A. and imported. We have a wide selection of TOPS, DRESSES, LEGGINGS, BASICS, OUTERWEARS, and much more.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:05.680Z",
    importedBy: "entity-db-cli",
  },
};
